import { isShuttingDown, SHUTDOWN_DATE_LABEL } from 'lib/shutdown'

// Shown at the top of every app page during the Outcast wind-down.
export const ShutdownBanner = () => {
  if (!isShuttingDown()) return null

  return (
    <div className="flex items-center justify-center bg-amber-50 px-6 py-2.5 text-center text-sm leading-6 text-amber-900">
      <p>
        <strong className="font-semibold">
          Outcast is shutting down on {SHUTDOWN_DATE_LABEL}.
        </strong>{' '}
        Your credits work until then. Please download anything you want to
        keep.
      </p>
    </div>
  )
}
